import { render, staticRenderFns } from "./AtaEdit.vue?vue&type=template&id=5c3f771c&scoped=true"
import script from "./AtaEdit.vue?vue&type=script&lang=js"
export * from "./AtaEdit.vue?vue&type=script&lang=js"
import style0 from "./AtaEdit.vue?vue&type=style&index=0&id=5c3f771c&prod&lang=css"
import style1 from "./AtaEdit.vue?vue&type=style&index=1&id=5c3f771c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f771c",
  null
  
)

export default component.exports